import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import GroupedDocsTable from 'components/table/documents/GroupedDocsTable';
import { usePermissionsContext } from 'store/permissions';
import { PermissionKeys } from 'store/types';
import { getSubdomain } from 'utils/helpers/routing';
import InnerWrapper from '../InnerWrapper';

const Screen: FC = () => {
  const [customSelectableRowProps, setCustomSelectableRowProps] = useState<any[]>([]);
  const [multiActionActive, setMultiActionActive] = useState(false);
  const { t } = useTranslation();
  const { checkPermission } = usePermissionsContext();
  const isOperator = getSubdomain() === 'operators';

  return (
    <InnerWrapper
      canMultiSign={
        checkPermission(PermissionKeys.CAN_MULTI_APPROVE) ||
        checkPermission(PermissionKeys.CAN_MULTI_SIGN) ||
        isOperator
      }
      customSelectableProps={customSelectableRowProps}
      setCustomSelectableRowProps={setCustomSelectableRowProps}
      setMultiActionActive={setMultiActionActive}
    >
      <GroupedDocsTable
        entityName="documents-received"
        entityEndpoint="document-holders"
        searchParams={{
          tab: 'received',
        }}
        isSelectable
        useCustomSelectBtn
        toggleSelectBtnLabel={t('documents.table.multiSign')}
        customSelectableRowProps={customSelectableRowProps}
        disablePagination={multiActionActive}
      />
    </InnerWrapper>
  );
};

export default Screen;
